import { useCallback, useMemo } from 'react';
import { detectLangFromNavigator, loadDictionary, t as tFn, type Lang } from '../utils/i18n';

interface UseI18nOptions {
  lang?: Lang;
}

export function useI18n(options?: UseI18nOptions) {
  const lang: Lang = options?.lang ?? detectLangFromNavigator();

  const dict = useMemo(() => loadDictionary(lang), [lang]);

  const t = useCallback((key: string) => tFn(dict, key), [dict]);

  return { lang, dict, t } as const;
}

export default useI18n;
